import SetFiscalRegimeError from './SetFiscalRegimeError';
class RegimeFileIsTooBig extends SetFiscalRegimeError {
    constructor(options) {
        super('Fiscal Regime File exceeds 5mb', options);
    }
}
export default RegimeFileIsTooBig;
